/**
 * Module keys this app ships.
 *
 * These are the strings that appear in a Dashboard record's UIConfigDetails
 * `modules` array, so they are a deployed contract — renaming one breaks every
 * metadata row that names it.
 *
 * The framework treats module keys as an open `string` on purpose (see
 * AGUAppLocation), but inside this app they are closed and derived, so a typo in
 * a module definition or a nav call is a compile error rather than a module that
 * silently never resolves.
 */
export const RA_MODULE_KEYS = {
    Dashboard: 'dashboard',
    Grants: 'grants',
    People: 'people',
    Jobs: 'jobs',
    Saved: 'saved',
    Profile: 'profile',
    Settings: 'settings',
    Search: 'search',
    CareerMap: 'career-map',
} as const;

export type RaModuleKey = (typeof RA_MODULE_KEYS)[keyof typeof RA_MODULE_KEYS];
